export default "__VITE_ASSET__CRlpP$oa__"